import React from "react"

export default function Footer() {
  return (
    <div
      style={{
        textAlign: "center",
        padding: "10px",
        backgroundColor: "#000",
        color: "#fff",
      }}
    >
      <a
        href="https://advertpark.com/"
        target="_blank"
        rel="noopener noreferrer"
        style={{color: "#fff", textDecoration: "none"}}
      >
        Powered By Advertpark
      </a>
    </div>
  )
}
